module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "fixed-content"
  }, [_c('div', {
    staticClass: "serachInput bg-fff"
  }, [_c('div', {
    staticClass: "dropdownBox"
  }, [_c('div', {
    staticClass: "dropdown font-size-14px",
    attrs: {
      "id": "trigger1"
    }
  }, [_vm._v(_vm._s(_vm.selectData.name))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown margin-left-20 font-size-14px",
    attrs: {
      "id": "trigger"
    }
  }, [_vm._v(_vm._s(_vm.nationsData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "serach bg-f5f5f5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "bg-f5f5f5 font-size-28",
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名／学号"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "deleteBtn",
    attrs: {
      "src": "static/images/searchDelete.png"
    },
    on: {
      "click": function($event) {
        return _vm.deletInput()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "serachBtn color-fff margin-left-20 font-size-14px",
    on: {
      "click": function($event) {
        return _vm.searchClick()
      }
    }
  }, [_vm._v("搜索")])])]), _vm._v(" "), _c('div', {
    staticClass: "padding-20 bg-appStyle color-fff"
  }, [_c('p', {
    staticClass: "font-size-14px"
  }, [_vm._v("总数：" + _vm._s(_vm.totalData.totalPerson) + "人")]), _vm._v(" "), _c('p', {
    staticClass: "font-size-14px margin-top-10"
  }, [_vm._v("在寝：" + _vm._s(_vm.totalData.inDormNum) + "人  不在寝：" + _vm._s(_vm.totalData.unDormNum) + "人  无活动：" + _vm._s(_vm.totalData.noActiveNum) + "人")]), _vm._v(" "), _c('p', {
    staticClass: "font-size-14px margin-top-10"
  }, [_vm._v("请假：" + _vm._s(_vm.totalData.leaveNum) + "人")])]), _vm._v(" "), _c('div', {
    staticClass: "cut-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "tabBtn"
  }, [_c('mt-navbar', {
    staticClass: "navBar",
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    staticClass: "tabBtnNav",
    attrs: {
      "id": "1"
    }
  }, [_vm._v("在寝" + _vm._s(_vm.totalData.inDormNum) + "人"), _c('p', [_vm._v("(" + _vm._s(_vm.totalData.leaveNumInInDorm) + "人)")])]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tabBtnNav",
    attrs: {
      "id": "2"
    }
  }, [_vm._v("不在寝" + _vm._s(_vm.totalData.unDormNum) + "人"), _c('p', [_vm._v("(" + _vm._s(_vm.totalData.leaveNumInUnDorm) + "人)")])]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tabBtnNav",
    attrs: {
      "id": "3"
    }
  }, [_vm._v("无活动" + _vm._s(_vm.totalData.noActiveNum) + "人"), _c('p', [_vm._v("(" + _vm._s(_vm.totalData.leaveNumInNoActive) + "人)")])]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tabBtnNav",
    attrs: {
      "id": "4"
    }
  }, [_vm._v("请假" + _vm._s(_vm.totalData.leaveNum) + "人")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border-bottom margin-top-20 bg-appStyle color-fff"
  }, [_c('mt-tab-container', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-container-item', {
    attrs: {
      "id": "1"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  学号\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  姓名\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-basis-80"
  }, [_vm._v("\n                  楼房号\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  日期\n                ")])])])]), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "2"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  学号\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  姓名\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-basis-80"
  }, [_vm._v("\n                  楼房号\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  日期\n                ")])])])]), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "3"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  学号\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  姓名\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-basis-80"
  }, [_vm._v("\n                  楼房号\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  原因\n                ")])])])]), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "4"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  姓名\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-basis-80"
  }, [_vm._v("\n                  楼房号\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n                  原因\n                ")])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-content"
  }, [_c('div', [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop,
      "bottom-method": _vm.loadBottom,
      "bottom-all-loaded": _vm.allLoaded,
      "auto-fill": false
    }
  }, [_c('mt-tab-container', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-container-item', {
    attrs: {
      "id": "1"
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [(_vm.list.length == 0) ? _c('div', {
    staticClass: "noData"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "7rem"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/default-null.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时无相关数据")])])]) : _vm._e(), _vm._v(" "), (_vm.list.length > 0) ? _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gridWarp"
    }, [_c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v("\n                      " + _vm._s(item.studentNo) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1",
      domProps: {
        "innerHTML": _vm._s(item.userName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-basis-80"
    }, [(item.dormAreaSimpleName && item.roomNum) ? _c('p', [_vm._v(_vm._s(item.dormAreaSimpleName))]) : _vm._e(), _vm._v(" "), (item.dormAreaSimpleName && item.roomNum) ? _c('p', [_vm._v(_vm._s(item.roomNum))]) : _vm._e(), _vm._v(" "), (!item.dormAreaSimpleName || !item.roomNum) ? _c('p', [_vm._v(_vm._s(item.dormRoomName))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v("\n                      " + _vm._s(item.lastFaceActionTime) + "\n                    ")])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "2"
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [(_vm.list.length == 0) ? _c('div', {
    staticClass: "noData"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "7rem"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/default-null.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时无相关数据")])])]) : _vm._e(), _vm._v(" "), (_vm.list.length > 0) ? _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gridWarp"
    }, [_c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v("\n                      " + _vm._s(item.studentNo) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1",
      domProps: {
        "innerHTML": _vm._s(item.userName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-basis-80"
    }, [(item.dormAreaSimpleName && item.roomNum) ? _c('p', [_vm._v(_vm._s(item.dormAreaSimpleName))]) : _vm._e(), _vm._v(" "), (item.dormAreaSimpleName && item.roomNum) ? _c('p', [_vm._v(_vm._s(item.roomNum))]) : _vm._e(), _vm._v(" "), (!item.dormAreaSimpleName || !item.roomNum) ? _c('p', [_vm._v(_vm._s(item.dormRoomName))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v("\n                      " + _vm._s(item.lastFaceActionTime) + "\n                    ")])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "3"
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [(_vm.list.length == 0) ? _c('div', {
    staticClass: "noData"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "7rem"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/default-null.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时无相关数据")])])]) : _vm._e(), _vm._v(" "), (_vm.list.length > 0) ? _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gridWarp"
    }, [_c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v("\n                      " + _vm._s(item.studentNo) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1",
      domProps: {
        "innerHTML": _vm._s(item.userName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-basis-80"
    }, [(item.dormAreaSimpleName && item.roomNum) ? _c('p', [_vm._v(_vm._s(item.dormAreaSimpleName))]) : _vm._e(), _vm._v(" "), (item.dormAreaSimpleName && item.roomNum) ? _c('p', [_vm._v(_vm._s(item.roomNum))]) : _vm._e(), _vm._v(" "), (!item.dormAreaSimpleName || !item.roomNum) ? _c('p', [_vm._v(_vm._s(item.dormRoomName))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v("\n                      " + _vm._s(item.reason) + "\n                    ")])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "4"
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [(_vm.list.length == 0) ? _c('div', {
    staticClass: "noData"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "7rem"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/default-null.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时无相关数据")])])]) : _vm._e(), _vm._v(" "), (_vm.list.length > 0) ? _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gridWarp"
    }, [_c('div', {
      staticClass: "gridCell flex-1",
      domProps: {
        "innerHTML": _vm._s(item.userName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-basis-80"
    }, [(item.dormAreaSimpleName && item.roomNum) ? _c('p', [_vm._v(_vm._s(item.dormAreaSimpleName))]) : _vm._e(), _vm._v(" "), (item.dormAreaSimpleName && item.roomNum) ? _c('p', [_vm._v(_vm._s(item.roomNum))]) : _vm._e(), _vm._v(" "), (!item.dormAreaSimpleName || !item.roomNum) ? _c('p', [_vm._v(_vm._s(item.dormRoomName))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v("\n                      " + _vm._s(item.reason) + "\n                    ")])])
  }), 0) : _vm._e()])])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-170714a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 835
// module chunks = 1